import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  GetSearchSectorsListAsync,
  GetSearchStatusesListAsync,
  ILicenceStatusesList,
  ISectorsList,
  ICountyList,
  GetCountiesAsync,
} from "../../api/ILicenceAdvancedSearch";
import {
  GetAuthorisationTypesAsync,
  IAuthorisationTypesList,
} from "../../api/ILicenceProfileSearch";
import { RootState } from "../store";

export interface LeapSearchState {
  fetchStatus: string;
  authorisationTypes?: IAuthorisationTypesList;
  sectorsList?: ISectorsList;
  licenseStatusesList?: ILicenceStatusesList;
  countyList?: ICountyList;
}

const initialState: LeapSearchState = {
  fetchStatus: "Loading...",
  authorisationTypes: undefined,
  sectorsList: undefined,
  licenseStatusesList: undefined,
  countyList: undefined,
};

export const loadLeapSearchOptionsAsync = createAsyncThunk(
  "leapSearch/loadOptions",
  async () => {
    const authTypes = await GetAuthorisationTypesAsync();
    const sectors = await GetSearchSectorsListAsync();
    const statuses = await GetSearchStatusesListAsync();
    const counties = await GetCountiesAsync();

    // The value we return becomes the `fulfilled` action payload
    return {
      authorisationTypes: authTypes,
      sectorsList: sectors,
      licenseStatusesList: statuses,
      countyList: counties,
    };
  }
);

export const leapSearchOptionsSlice = createSlice({
  name: "leapSearchOptions",
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {},
  // The `extraReducers` field lets the slice handle actions defined elsewhere,
  // including actions generated by createAsyncThunk or in other slices.
  extraReducers: (builder) => {
    builder
      .addCase(loadLeapSearchOptionsAsync.pending, (state) => {
        state.fetchStatus = "loading";
      })
      .addCase(loadLeapSearchOptionsAsync.fulfilled, (state, action) => {
        state.fetchStatus = "idle";
        state.authorisationTypes = action.payload.authorisationTypes;
        state.sectorsList = action.payload.sectorsList;
        state.licenseStatusesList = action.payload.licenseStatusesList;
        state.countyList = action.payload.countyList;
      });
  },
});

export const selectLeapSearchOptions = (state: RootState) =>
  state.leapSearchOptions;

export default leapSearchOptionsSlice.reducer;
